export default "__VITE_ASSET__68TcAz0v__"